import {
  AdminGlobalSearchCountResponse,
  AdminGlobalSearchFilter,
  AdminGlobalSearchItem,
} from '../../graphql/API';
import { adminGlobalSearch, adminGlobalSearchCount } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

/**
 * Header global search: one call brings the first rows of every entity, a second one
 * the totals of the entities whose page came back full.
 */

export const adminGlobalSearchApi = async (
  filter: AdminGlobalSearchFilter,
): Promise<AdminGlobalSearchItem[]> => {
  const result = await executeGql(adminGlobalSearch, { filter });
  return processGqlResult<AdminGlobalSearchItem[]>('adminGlobalSearch.items', result) ?? [];
};

export const adminGlobalSearchCountApi = async (
  filter: AdminGlobalSearchFilter,
): Promise<AdminGlobalSearchCountResponse> => {
  const result = await executeGql(adminGlobalSearchCount, { filter });
  return processGqlResult<AdminGlobalSearchCountResponse>('adminGlobalSearchCount', result) ?? {};
};
